import dayjs from 'dayjs'

export function getProposeTimeUserId(auth) {
    return auth.getActiveMember()?.id || auth.getUser()?.id
}

export function buildProposeTimeQuery(auth, referral, locationId, distance) {
    const created = referral?.createdAt || referral?.createdDateTime
    const appointmentDate = referral?.appointmentDateTime
    const isFromPatient = Boolean(referral?.isFromPatient)

    return {
        physicianId: auth.getActiveMember()?.id || auth.getUser().id,
        practiceId: auth.getPractice().id,
        userId: getProposeTimeUserId(auth),
        practiceLocationId: locationId,
        fromUserId: referral?.fromUser?.id,
        timeFrame: referral?.timeframe,
        fromDate:
            referral?.timeframe === 'custom' && referral?.customDate
                ? dayjs(referral.customDate).format('YYYY-MM-DD')
                : appointmentDate && dayjs(appointmentDate).isAfter(dayjs())
                ? dayjs(appointmentDate).format('YYYY-MM-DD')
                : created
                ? dayjs(created).format('YYYY-MM-DD')
                : dayjs().format('YYYY-MM-DD'),
        distance: distance ?? undefined,
        practiceType: auth.getPractice().practiceType,
        isFromPatient: isFromPatient ? 'true' : undefined,
        patientId: isFromPatient ? referral?.patientId || referral?.patient?.id : undefined,
    }
}

export function isReferralEntity(item) {
    if (!item) return false
    if (item.isReferralPool === true) return false

    if (item.sourceType === 'referrals_pool' || item.sourceType === 'match') {
        return item.status === 'RESCHEDULE_REQUESTED_BY_PATIENT'
    }

    if (item.sourceType === 'direct' || item.sourceType === 'referral') return true
    if (item.status === 'RESCHEDULE_REQUESTED_BY_PATIENT') return true
    if (item.isReferral === true) return true
    return false
}

export function goToProposeTime(router, auth, referralOrData, referralType = 'received') {
    const id = referralOrData.id || referralOrData.referralId
    if (!id) return

    const referral = referralOrData.id ? referralOrData : { id, referralId: id }
    const isReferral = isReferralEntity(referralOrData)

    if (isReferral) {
        const locationId = Number(referralOrData.practiceLocationId || referralOrData.practiceLocation?.id || 0)
        router.push({
            name: 'referrals.propose.time',
            params: { referralId: id, locationId },
            query: {
                referralType,
                pendingInit: '1',
                ...buildProposeTimeQuery(auth, referral, locationId),
            },
        })
        return
    }

    const poolId = id
    router.push({
        name: 'referrals.pool.propose.time',
        params: { poolId, locationId: 0 },
        query: {
            referralType,
            pendingInit: '1',
            ...buildProposeTimeQuery(auth, referral, 0),
        },
    })
}
